import * as React from 'react'
import { Link } from 'react-router-dom'
import { ImportRoute } from "@framework/AsyncImport";

export function start(options: { routes: JSX.Element[] }) {

  options.routes.push(<ImportRoute path="~/party/createUser" onImportModule={() => import("./Templates/CreateUser")} />);

}

export function getSignUpButtonComponent() {
  return <Link to="~/party/createUser">Create User</Link>;
}
